import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const SmallTriangleRightIcon = createSvgIcon(
  <>
    <title>small triangle right</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <polygon
        fill="none"
        points="11,23 11,9 21,16 "
        stroke="#222222"
        strokeMiterlimit="10"
        transform="translate(0, 0)"
      />
    </g>
  </>
)
